import axios from 'axios';
import { FETCH_WEBINAR_URL } from 'appenv';

function fetchAllWebinars() {
  return axios.get(FETCH_WEBINAR_URL).then((result) => result.data.data);
}

export default fetchAllWebinars;
